import { useLocation, useNavigate } from "react-router-dom";

export const withRouter = (Component) => {
  return function Wrapper(props) {
    const location = useLocation();
    const navigate = useNavigate();

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
      />
    );
  };
};